export default {
  app: {
    name: 'KissMyWheels',
    logout: 'Déconnexion'
  },
  common: {
    home: 'Accueil',
    booking: 'Réservation',
    appointments: 'Rendez-vous',
    settings: 'Paramètres',
    save: 'Enregistrer',
    cancel: 'Annuler',
    back: 'Retour',
    continue: 'Continuer',
    confirm: 'Confirmer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    date: 'Date',
    time: 'Heure',
    status: 'Statut',
    service: 'Service',
    store: 'Boutique',
    all: 'Tous',
    search: 'Rechercher...',
    view: 'Voir',
    edit: 'Modifier',
    actions: 'Actions',
    delete: 'Supprimer',
    saving: 'Enregistrement...',
    deleting: 'Suppression...',
    create: 'Créer',
    backToHome: 'Retour à l\'accueil'
  },
  home: {
    hero: {
      title: 'Bienvenue sur notre plateforme de réservation',
      subtitle: 'Prenez rendez-vous en quelques clics',
      cta: 'Prendre rendez-vous'
    },
    howItWorks: {
      title: 'Comment ça marche ?',
      step1: {
        title: '1. Choisissez votre boutique',
        description: 'Sélectionnez la boutique la plus proche de chez vous'
      },
      step2: {
        title: '2. Sélectionnez un créneau',
        description: 'Choisissez la date et l\'heure qui vous conviennent'
      },
      step3: {
        title: '3. Confirmez votre rendez-vous',
        description: 'Recevez une confirmation par email'
      }
    },
    advantages: {
      title: 'Pourquoi nous choisir ?',
      simple: {
        title: 'Simple et rapide',
        description: 'Réservez en moins de 2 minutes'
      },
      flexible: {
        title: 'Flexible',
        description: 'Modifiez ou annulez facilement votre rendez-vous'
      },
      reminders: {
        title: 'Rappels automatiques',
        description: 'Recevez des notifications par email'
      }
    }
  },
  stores: {
    title: 'Nos boutiques',
    comingSoon: 'Prochainement',
    availableServices: 'Services disponibles',
    bookNow: 'Réserver maintenant',
    selectStore: 'Choisissez une boutique',
    noStores: 'Aucune boutique disponible',
    noStoresFound: 'Aucune boutique trouvée',
    closed: 'Fermé',
    management: {
      title: 'Gestion des magasins',
      addStore: 'Ajouter un magasin',
      editStore: 'Modifier le magasin',
      city: 'Ville',
      cityKey: 'Clé de la ville',
      name: 'Nom',
      address: 'Adresse',
      zip: 'Code postal',
      phone: 'Téléphone',
      email: 'Email',
      status: 'Statut',
      services: 'Services',
      workingHours: 'Horaires d\'ouverture',
      isOpen: 'Ouvert',
      isActive: 'Actif',
      isComingSoon: 'Prochainement',
      active: 'Actif',
      inactive: 'Inactif',
      confirmDelete: 'Confirmer la suppression',
      deleteWarning: 'Êtes-vous sûr de vouloir supprimer ce magasin ? Cette action est irréversible.',
      loadError: 'Erreur lors du chargement des magasins',
      saveError: 'Erreur lors de l\'enregistrement du magasin',
      deleteError: 'Erreur lors de la suppression du magasin',
      createSuccess: 'Magasin créé avec succès',
      updateSuccess: 'Magasin mis à jour avec succès',
      deleteSuccess: 'Magasin supprimé avec succès'
    }
  },
  services: {
    title: 'Nos Services',
    escooter: {
      title: 'Trottinettes Électriques',
      description: 'Location et entretien de trottinettes électriques'
    },
    emotorcycle: {
      title: 'Scooters Électriques',
      description: 'Location et entretien de scooters électriques'
    },
    ebike: {
      title: 'Vélos Électriques',
      description: 'Location et entretien de vélos électriques'
    },
    repair: 'Réparation',
    trial: 'Essai',
    trial_description: 'Essayez nos véhicules électriques',
    repair_description: 'Service de réparation et maintenance',
    selectService: 'Choisissez un service',
    tires: 'Pneus',
    maintenance: 'Révision',
    brakes: 'Freins',
    oil: 'Vidange'
  },
  booking: {
    title: 'Prendre un rendez-vous',
    selectStore: 'Sélectionner cette boutique',
    steps: {
      store: 'Boutique',
      service: 'Service',
      datetime: 'Date et heure',
      info: 'Informations'
    },
    selectDate: 'Choisissez une date',
    selectTime: 'Choisissez une heure',
    personalInfo: 'Vos informations',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    comments: 'Commentaires (optionnel)',
    submit: 'Confirmer le rendez-vous',
    success: 'Réservation confirmée',
    error: 'Erreur lors de la réservation',
    confirmationTitle: 'Réservation confirmée !',
    confirmationMessage: 'Votre rendez-vous a été enregistré avec succès. Vous recevrez bientôt un email de confirmation.',
    details: 'Détails de votre rendez-vous',
    addToCalendar: 'Ajouter à votre calendrier',
    addToGoogle: 'Ajouter à Google Calendar',
    addToApple: 'Ajouter à iCal/Apple Calendar',
    submitError: 'Une erreur est survenue lors de la réservation.',
    weekDays: {
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mer',
      thu: 'Jeu',
      fri: 'Ven',
      sat: 'Sam',
      sun: 'Dim'
    },
    months: {
      january: 'Janvier',
      february: 'Février',
      march: 'Mars',
      april: 'Avril',
      may: 'Mai',
      june: 'Juin',
      july: 'Juillet',
      august: 'Août',
      september: 'Septembre',
      october: 'Octobre',
      november: 'Novembre',
      december: 'Décembre'
    },
    storeClosed: "Le magasin est fermé ce jour",
    noAvailableSlots: "Aucun créneau disponible pour cette date"
  },
  appointment: {
    details: 'Détails du rendez-vous',
    management: 'Gestion des rendez-vous',
    description: 'Gérez tous les rendez-vous de vos clients',
    new: 'Nouveau rendez-vous',
    client: 'Client',
    noAppointments: 'Aucun rendez-vous trouvé',
    searchPlaceholder: 'Rechercher par nom, email ou téléphone...',
    status: {
      pending: 'En attente',
      confirmed: 'Confirmé',
      cancelled: 'Annulé'
    },
    actions: {
      cancel: 'Annuler le rendez-vous',
      reschedule: 'Modifier le rendez-vous'
    }
  },
  errors: {
    404: {
      title: 'Page non trouvée',
      message: 'Désolé, la page que vous recherchez n\'existe pas ou a été déplacée.',
      backHome: 'Retour à l\'accueil'
    },
    generic: {
      title: 'Une erreur est survenue',
      message: 'Désolé, quelque chose s\'est mal passé. Veuillez réessayer plus tard.',
      retry: 'Réessayer'
    }
  },
  days: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
    undefined: 'Jour non défini',
    0: 'Lundi',
    1: 'Mardi',
    2: 'Mercredi',
    3: 'Jeudi',
    4: 'Vendredi',
    5: 'Samedi',
    6: 'Dimanche'
  },
  admin: {
    title: 'Administration',
    dashboard: {
      title: 'Tableau de bord',
      stats: {
        stores: 'Magasins',
        employees: 'Employés',
        services: 'Services'
      },
      appointmentsPerDay: 'Rendez-vous par jour',
      appointmentsPerStore: 'Rendez-vous par magasin',
      chartComingSoon: 'Graphique à venir',
      recentAppointments: 'Derniers rendez-vous',
      noAppointments: 'Aucun rendez-vous',
      table: {
        date: 'Date',
        time: 'Heure',
        store: 'Magasin',
        client: 'Client',
        status: 'Statut',
        service: 'Service'
      }
    },
    stores: {
      title: 'Gestion des magasins',
      addStore: 'Ajouter un magasin',
      editStore: 'Modifier le magasin',
      deleteStore: 'Supprimer le magasin',
      comingSoon: 'Prochainement',
      city: 'Ville',
      cityKey: 'Clé de la ville',
      name: 'Nom',
      address: 'Adresse',
      zip: 'Code postal',
      phone: 'Téléphone',
      email: 'Email',
      status: 'Statut',
      services: 'Services',
      workingHours: 'Horaires d\'ouverture',
      isOpen: 'Ouvert',
      isActive: 'Actif',
      isComingSoon: 'Prochainement',
      active: 'Actif',
      inactive: 'Inactif',
      confirmDelete: 'Confirmer la suppression',
      deleteWarning: 'Êtes-vous sûr de vouloir supprimer ce magasin ? Cette action est irréversible.',
      loadError: 'Erreur lors du chargement des magasins',
      saveError: 'Erreur lors de l\'enregistrement du magasin',
      deleteError: 'Erreur lors de la suppression du magasin',
      createSuccess: 'Magasin créé avec succès',
      updateSuccess: 'Magasin mis à jour avec succès',
      deleteSuccess: 'Magasin supprimé avec succès',
      noStores: 'Aucun magasin trouvé',
      form: {
        name: 'Nom',
        city: 'Ville',
        cityKey: 'Clé de la ville',
        selectCity: 'Sélectionner une ville',
        address: 'Adresse',
        zipCode: 'Code postal',
        zip: 'Code postal',
        services: 'Services',
        status: 'Statut',
        email: 'Email',
        phone: 'Téléphone',
        workingHours: 'Horaires d\'ouverture'
      }
    },
    employees: {
      title: 'Gestion des employés',
      addEmployee: 'Ajouter un employé',
      editEmployee: 'Modifier l\'employé',
      deleteEmployee: 'Supprimer l\'employé',
      name: 'Nom',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      store: 'Magasin',
      password: 'Mot de passe',
      status: 'Statut',
      isActive: 'Actif',
      active: 'Actif',
      inactive: 'Inactif',
      noStore: 'Aucun magasin',
      leaveBlankPassword: 'Laisser vide pour conserver le mot de passe actuel',
      noEmployees: 'Aucun employé trouvé',
      confirmDelete: 'Confirmer la suppression',
      deleteWarning: 'Êtes-vous sûr de vouloir supprimer cet employé ? Cette action est irréversible.',
      loadError: 'Erreur lors du chargement des employés',
      saveError: 'Erreur lors de l\'enregistrement de l\'employé',
      deleteError: 'Erreur lors de la suppression de l\'employé',
      createSuccess: 'Employé créé avec succès',
      updateSuccess: 'Employé mis à jour avec succès',
      deleteSuccess: 'Employé supprimé avec succès',
      form: {
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        store: 'Magasin',
        selectStore: 'Sélectionner un magasin',
        role: 'Rôle',
        status: 'Statut'
      }
    }
  },
  auth: {
    login: {
      title: 'Connexion',
      email: 'Adresse e-mail',
      password: 'Mot de passe',
      rememberMe: 'Se souvenir de moi',
      forgotPassword: 'Mot de passe oublié ?',
      submit: 'Se connecter',
      loggingIn: 'Connexion en cours...',
      errors: {
        emailRequired: 'L\'adresse e-mail est requise',
        emailInvalid: 'L\'adresse e-mail n\'est pas valide',
        passwordRequired: 'Le mot de passe est requis',
        default: 'Identifiants incorrects'
      }
    },
    logout: 'Déconnexion'
  },
  roles: {
    manager: 'Responsable',
    mechanic: 'Mécanicien',
    apprentice: 'Apprenti'
  }
} 